import {Injectable} from "@angular/core";
import {Actions} from "@ngrx/effects";
import {Action, Store} from "@ngrx/store";
import {take, takeWhile} from "rxjs/operators";
import {AppState} from "../../store/state/app.state";
import {orderSelector} from "../../store/state/state.selectors";

@Injectable({providedIn: "root"})
export class ActionsRecorderService {

	private active: boolean;
	private recordedActions: Action[] = [];

	constructor(private actions: Actions, private store: Store<AppState>) {
	}

	startRecording(logActionsInConsole ?: boolean): void {
		console.info('Starting recording ngrx actions with logActionsInConsole=', logActionsInConsole);
		this.active = true;
		this.actions.pipe(takeWhile(() => this.active)).subscribe(action => {
			this.recordedActions.push(action);

			if (logActionsInConsole) {
				this.store.select(orderSelector).pipe(take(1)).subscribe(order => {
					console.info('ACTION: ', action);
					console.info('ORDER: ', order);
				});
			}
		})
	}

	stopRecording(): void {
		this.active = false;
	}

	getRecordedActions(): Action[] {
		return this.recordedActions;
	}
}
